export const rules = {
  email: [{ required: true }],
  password: [{ required: true }],
};
